import { pathToRegexp } from 'path-to-regexp';

import type { ManifestMap } from '@xing-com/crate-core-assets';

import type { Site } from './detect-site';
import type { Route } from './extract-routes';
import { CATCH_ALL_ROUTE, extractRoutes } from './extract-routes';

export type RouteMatcher = (url: string) => Route;

export function getPath(url: string): string {
  return url.split(/[?#]/, 1)[0];
}

export function createRouteMatcher(
  manifestMap: ManifestMap,
  filterBySite: Site = 'xing'
): RouteMatcher {
  const routes = extractRoutes(manifestMap, filterBySite).map(
    (route): [RegExp, Route] => [pathToRegexp(route.path).regexp, route]
  );

  return (url) => {
    const route = routes.find(([regexp]) => regexp.test(getPath(url)))?.[1];

    return (
      route ?? {
        owner: 'unknown',
        parents: [],
        path: CATCH_ALL_ROUTE,
        route: CATCH_ALL_ROUTE,
        site: 'xing',
        xinglet: 'unknown',
        config: {},
      }
    );
  };
}
